export const environment = {
  production: true,
  filesServiceUrl: 'https://files.cityzvision.fr',
  supabaseUrl: 'https://dfnzxlfdqyamdktumiws.supabase.co',
  supabaseKey: 'sb_publishable_vxwgfbRNx6pL-MKtPrRLKA_aPnmK_LX',
  adobeKey: '3f365d6a1afd4bd790702c96510628c3'
};
